import React, {useContext, useState} from 'react';
import {SellFactorSCLContext} from "../SellFactorContext";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import {v4 as uuidV4} from 'uuid';
import {toast} from "react-toastify";
import utilsFunction from "../../../utils/utilsFunction";
import {sumEachRow} from "./functions";

function SclJozSelectOptionAdder(props) {
  const helper = useContext(SellFactorSCLContext);
  const setData = helper.setData
  const data = helper.data;


  console.log(data)


  const [priceList, setPriceList] = useState([])

  const defaultSelectedData = {
    rowId: "",
    recordId: "",
    productId: "",
    productName: "",
    priceId: "",
    price: "",
    unit: "",
    weight: "0",
    discount: 0,
    factorStatus: "inProcess",

  }
  const [selectedData, setSelectedData] = objectDataHolder(defaultSelectedData)

  const ProductChangeHandler = (e) => {
    const selectedProductId = e.target.value;
    const selectedIndex = e.target.selectedIndex
    const productName = e.target.options[selectedIndex].label;
    let newPriceList = data.initialData.productData.filter(v => +v.productId === +selectedProductId)
    newPriceList = newPriceList[0].priceList

    const newSelectedData = {
      productId: selectedProductId, productName: productName,

      discount: 0, factorStatus: "inProcess",
    }
    setSelectedData(newSelectedData)
    setPriceList(newPriceList)
  }


  const priceChangeHandler = e => {
    const value = e.target.value;
    const selectedIndex = e.target.selectedIndex
    const price = e.target.options[selectedIndex].label;

    // setSelectedData({priceId: e.target.value})
    const newSelectedData = {
      priceId: value, price: price,
    }
    setSelectedData(newSelectedData)
  }

  const addToTableHandler = () => {

    if (selectedData.productId === "") {
      toast("لطفا یک محصول معتبر انتخاب کنید")
      return
    }

    if (selectedData.priceId === "") {
      toast("لطفا یک قیمت معتبر انتخاب کنید")
      return
    }



    // آیا کالا تکراری هست؟
    const isSelectSame = data.sendData.productsData.find(v => v.productId === selectedData.productId && v.priceId === selectedData.priceId)

    if (isSelectSame) {
      toast.info("کالا تکراری...")
      return;
    }
    const tempSelectedData = {...selectedData}

    if (true) {
      tempSelectedData.uniqId = uuidV4()
    }

    const newProductData = [...data.sendData.productsData, tempSelectedData]

    const newProductData1 = utilsFunction.addRowIdToTable(newProductData)
    const newProductData2 = sumEachRow(newProductData1)
    setData({sendData: {...data.sendData, productsData: newProductData2}})
    setSelectedData(defaultSelectedData)
    setPriceList([])
  }


  try {
    return (<div className={"d-flex align-items-start"}>

      <div className={"divgroup mx-2"}>
        <label htmlFor=""> انتخاب محصول</label>
        <select
          value={selectedData.productId}
          onChange={ProductChangeHandler}
          className={"form-select width__200"}
          name="" id="">
          <option value="">انتخاب کنید</option>
          {data.initialData.productData.map((row, index) => <option key={index}
                                                                    value={row.productId}>{row.productName}</option>)}
        </select>
      </div>


      <div className={"divgroup mx-2"}>

        <label htmlFor=""> انتخاب قیمت</label>
        <select name="" id=""

                value={selectedData.priceId}
                onChange={priceChangeHandler}
                className={"form-select width__200"}
        >
          <option value="">انتخاب کنید</option>
          {priceList.map((row, index) => <option
            key={index}
            value={row.priceId}>{row.price}</option>)}
        </select>

      </div>
      <div className={"divgroup mx-2"}>
        <button className={"btn btn-success"}
                onClick={addToTableHandler}
        >افزودن
        </button>
      </div>


    </div>);

  } catch (error) {
    return <>{error.toString()}</>
  }

}

export default SclJozSelectOptionAdder;